import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignPackageListPage",
  components: {
    InlinePrompt
  },
  props: {
    /**
     * Normalized requests
     */
    clientApplicationRequests: {
      type: Object,
      default: () => ({})
    },
    reminding: {
      type: Object,
      required: true
    }
  },
  computed: {
    clientApplicationRequestValues() {
      return _Object$values(this.clientApplicationRequests);
    },
    isValid() {
      return true;
    },
    table() {
      return {
        columns: ["id", "status", "subject", "date", "actions"],
        options: {
          orderBy: {
            column: "date"
          },
          skin: "table table-hover",
          uniqueKey: "clientApplicationRequestId",
          hiddenColumns: ["id"],
          filterable: false,
          sortable: [],
          perPage: 999999,
          headings: {
            status: this.$t("global.words.status"),
            subject: this.$t("global.words.subject"),
            date: this.$t("global.words.date"),
            actions: ""
          },
          showChildRowToggler: false,
          tabbable: false,
          columnsClasses: {
            status: "w-15",
            subject: "w-50",
            date: "w-30",
            actions: "w-auto"
          },
          texts: {
            noResults: this.$t("e-sign-package.messages.emptyDocs")
          }
        }
      };
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    showDetails({
      clientApplicationRequestId
    }) {
      this.$refs.table.toggleChildRow(clientApplicationRequestId);
    },
    updateStatus({
      clientApplicationRequestId
    }) {
      this.$emit("change-status", {
        clientApplicationRequestId
      });
    },
    sendReminder({
      clientApplicationRequestId
    }) {
      this.$emit("remind", {
        clientApplicationRequestId
      });
    },
    getBadgeType(status) {
      var _context;
      if (status === "sent") return "bg-light-gray text-white";
      if (status === "signed" || status === "completed") return "badge-success";
      if (_includesInstanceProperty(_context = ["awaiting_signature", "pending"]).call(_context, status)) return "badge-warning";
      return "badge-danger";
    },
    showCancel(status) {
      var _context2;
      return !_includesInstanceProperty(_context2 = ["cancelled", "requested-cancel", "completed"]).call(_context2, status);
    },
    showReminder(status) {
      return status === "sent";
    }
  }
});